export var Academies = {
    "Aix-marseille": "Aix-Marseille",
    Amiens: "Amiens",
    Besancon: "Besancon",
    Bordeaux: "Bordeaux",
    "Clermont-ferrand": "Clermont-ferrand",
    Corse: "Corse",
    Creteil: "Creteil",
    Dijon: "Dijon",
    Grenoble: "Grenoble",
    Guadeloupe: "Guadeloupe",
    Guyane: "Guyane",
    "La Reunion": "La Reunion",
    Lille: "Lille",
    Limoges: "Limoges",
    Lyon: "Lyon",
    Martinique: "Martinique",
    Mayotte: "Mayotte",
    Montpellier: "Montpellier",
    "Nancy-metz": "Nancy-Metz",
    Normandie: "Normandie",
    Nantes: "Nantes",
    Nice: "Nice",
    "Orleans-tours": "Orleans-Tours",
    Paris: "Paris",
    Poitiers: "Poitiers",
    Reims: "Reims",
    Rennes: "Rennes",
    Strasbourg: "Strasbourg",
    Toulouse: "Toulouse",
    Versailles: "Versailles"
};
export var emailDomainToAcademie = {
    "ac-aix-marseille.fr": "Aix-marseille",
    "ac-amiens.fr": "Amiens",
    "ac-besancon.fr": "Besancon",
    "ac-bordeaux.fr": "Bordeaux",
    "ac-caen.fr": "Caen",
    "ac-clermont.fr": "Clermont-ferrand",
    "ac-corse.fr": "Corse",
    "ac-creteil.fr": "Creteil",
    "ac-dijon.fr": "Dijon",
    "ac-grenoble.fr": "Grenoble",
    "ac-guadeloupe.fr": "Guadeloupe",
    "ac-guyane.fr": "Guyane",
    "ac-reunion.fr": "La Reunion",
    "ac-lille.fr": "Lille",
    "ac-limoges.fr": "Limoges",
    "ac-lyon.fr": "Lyon",
    "ac-martinique.fr": "Martinique",
    "ac-mayotte.fr": "Mayotte",
    "ac-montpellier.fr": "Montpellier",
    "ac-nancy-metz.fr": "Nancy-metz",
    "ac-nantes.fr": "Nantes",
    "ac-normandie.fr": "Normandie",
    "ac-nice.fr": "Nice",
    "ac-orleans-tours.fr": "Orleans-tours",
    "ac-paris.fr": "Paris",
    "ac-poitiers.fr": "Poitiers",
    "ac-reims.fr": "Reims",
    "ac-rennes.fr": "Rennes",
    "ac-rouen.fr": "Rouen",
    "ac-strasbourg.fr": "Strasbourg",
    "ac-toulouse.fr": "Toulouse",
    "ac-versailles.fr": "Versailles",
    "ac-polynesie.pf": "Polyn\xe9sie FR",
    "ac-wf.wf": "Wallis et Futuna",
    "ac-noumea.nc": "Nouvelle-cal\xe9donie",
    "ac-spm.fr": "Saint Pierre et Miquelon"
};
export function getAcademieDomainList() {
    return Object.keys(emailDomainToAcademie);
}
